import { GroupItem, GroupRequest } from "../types/groupItem";
import { CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost } from "./Requests";
import { PaginationParameters, PaginationResult, toQueryParameters } from "./Pagination";
import { EmployeeGeneral } from "../types/employeeType";
import { GroupFilterParameters, GroupsPageFiltersResponse } from "../types/groupPageFilters";

export const groupsApi = {
  getGroupPageFilters: async (): Promise<CallResult<GroupsPageFiltersResponse>> => {
    return await doApiGet<GroupsPageFiltersResponse>(
      `/api/companies/current/groups/filter`
    );
  },

  getGroups: async (
    pagination: PaginationParameters,
    filters: GroupFilterParameters = { actionModuleIds: [], serviceModuleIds: [], shopModuleIds: [] }
  ): Promise<CallResult<PaginationResult<GroupItem>>> => {
    const filterParams = [
      ...filters.actionModuleIds.map(id => `&actionModuleIds=${id}`),
      ...filters.serviceModuleIds.map(id => `&serviceModuleIds=${id}`),
      ...filters.shopModuleIds.map(id => `&shopModuleIds=${id}`),
    ].join('');
    return await doApiGet<PaginationResult<GroupItem>>(
      `/api/companies/current/taxbenefitgroups?${toQueryParameters(pagination)}${filterParams}`
    );
  },

  getGroupMembers: async (
    groupId: number
  ): Promise<CallResult<EmployeeGeneral[]>> => {
    return await doApiGet<EmployeeGeneral[]>(
      `/api/companies/current/groups/${groupId}/members`
    );
  },

  getAllGroups: async (): Promise<CallResult<GroupItem[]>> => {
    return await doApiGet<GroupItem[]>("/api/companies/current/groups");
  },

  getAllGroupsOfCompany: async (companyId: number): Promise<CallResult<GroupItem[]>> => {
    return await doApiGet<GroupItem[]>(`/api/companies/${companyId}/groups`);
  },

  createGroup: async (
    groupData: Partial<GroupItem>
  ): Promise<CallResult<GroupItem>> => {
    return await doApiPost("/api/companies/current/groups", groupData);
  },

  editGroup: async (
    id: number,
    groupData: GroupRequest
  ): Promise<CallResult<GroupItem>> => {
    return await doApiPatch(`/api/companies/current/groups/${id}`, groupData);
  },

  deleteGroup: async (
    id: number
  ): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/current/groups/${id}`);
  },
};
